(function () {
  "use strict";

  // ---- CONFIG: everything you are likely to tweak lives in this block ----
  // rate = actual raw filament cost per gram (₹800/kg = ₹0.8/g), NOT a selling price -
  // electricity/wear/maintenance/consumables/buffer/margin are added on top by the
  // formula below. Putting any markup into `rate` itself double-counts profit.
  // Keys must match the <option> values in snippets/instant-quote-modal.liquid. `base` picks
  // the power draw below. Rate is the everyday-stock cost per gram; some colours in a category
  // cost more (see LINES in page.print-pricer) - that gets confirmed on WhatsApp. ABS/ASA disabled.
  var MATERIALS = {
    "pla": { label: "PLA", base: "pla", rate: 0.94, density: 1.24 },
    "pla-plus": { label: "PLA+", base: "pla", rate: 0.94, density: 1.24 },
    "pla-silk": { label: "PLA Silk", base: "pla", rate: 1.0, density: 1.24 },
    "tri-silk": { label: "Tri-Colour Silk", base: "pla", rate: 1.25, density: 1.24 },
    "pla-matte": { label: "PLA Matte", base: "pla", rate: 0.94, density: 1.24 },
    "petg-hs": { label: "PETG High-Speed", base: "petg", rate: 1.25, density: 1.27 },
    "petg-translucent": { label: "PETG Translucent", base: "petg", rate: 1.38, density: 1.27 }
  };


  // Where the quote gets sent - same number the print-pricer page uses.
  var WHATSAPP_NUMBER = "917389486551";

  // Supabase Edge Function that saves every generated quote.
  var INSTANT_QUOTE_API = "https://arvbhinfnompczjisezm.supabase.co/functions/v1/instant-quote";

  var INFILL_OPTIONS = [15, 25, 50, 100]; // percent
  var DEFAULT_INFILL = 25;

  // Walls + top/bottom layers print fully solid no matter what infill % is set - only
  // the interior actually varies with infill. Without accounting for this, weight comes
  // out too low (worst at low infill, since the old formula scaled the WHOLE volume by
  // infill%). This is the fraction of the model's volume treated as always-solid shell;
  // tune it against a few real prints (higher for small/detailed parts, lower for large
  // simple ones - 0.15-0.20 is a reasonable average for typical wall counts/layer heights).
  var SHELL_FACTOR = 0.18;

  var GST_RATE = 0.18; // preview only, see note above
  var MIN_CHARGE_RS = 0; // set e.g. 99 for a minimum order charge, 0 = no minimum

  // Print time shown here is an estimate only (grams / average print speed) - it does
  // not affect price. Real per-job time needs an actual slicer, which we don't run here.
  var PRINT_SPEED_G_PER_HOUR = { pla: 22, petg: 16 };

  // Pieces >= this count are flagged as wholesale in the UI so the customer sees it
  // before messaging - the discount itself is applied manually when we reply on WhatsApp.
  var WHOLESALE_MIN_QTY = 10;

  // Client-side cap only, to avoid trying to parse an unreasonably large file in the browser.
  var MAX_FILE_MB = 1024;

  // 3MF is a zip archive; JSZip is loaded on demand only when a .3mf is picked.
  var JSZIP_URL = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";

  // Used only as a fallback when a G-code's own metadata gives filament length/volume
  // instead of a direct weight (most slicers give weight directly, so this rarely fires).
  var FILAMENT_DIAMETER_MM = 1.75;

  // ---- Real running-cost model (Bambu Lab A1, measured where noted) ----
  // Average watts drawn WHILE PRINTING (not idle, not the ~1100-1300W heating spike).
  // PLA = 95W, measured directly. PETG wasn't measured on its own, but the same board
  // bounds "active printing" at 80-150W "during regular PETG/PLA" - since PETG runs
  // hotter (nozzle + bed) than PLA's measured 95W, this uses the upper end of that same
  // range rather than a blind guess. TPU wasn't on the board at all - still an estimate,
  // close to PLA since it prints at a similar temperature range. Replace with your own
  // measured PETG/TPU averages once you have them.
  var MATERIAL_POWER_WATTS = { pla: 95, petg: 135 };

  var PRINTER_PRICE_RS = 47000; // Bambu Lab A1 + AMS Lite combo - set to your actual purchase price
  var PRINTER_LIFESPAN_HOURS = 4000; // estimate - update once you have real duty-cycle data

  // CSEDCL-style slab tariff: 0-100=6.50, 101-400=7.60, 400+=9.10 (₹/unit). A print farm
  // running regularly is unlikely to stay in the cheap slabs, so this uses the TOP slab -
  // underestimating electricity cost is exactly how a "per-gram" price quietly loses money.
  var ELECTRICITY_RATE_PER_UNIT = 11.38;

  // % on top of (material + electricity + wear) to cover failed prints and minor waste
  // this model doesn't otherwise capture.
  var FAILURE_BUFFER_PCT = 0.10;

  // Purge/skirt filament lost per job, independent of the model itself. Multicolor jobs
  // waste far more because the AMS purges filament on every color swap - these are rough
  // starting numbers to calibrate against real weighed waste once you have it.
  var SINGLE_COLOR_WASTE_G = 8;
  var PURGE_PER_EXTRA_COLOR_G = 4;

  // Small recurring costs a per-gram/per-hour model otherwise misses entirely.
  var CONSUMABLES_COST_RS = 6; // per job - glue stick/adhesive, isopropyl cleaning, nozzle wear
  var MAINTENANCE_RATE_PER_HOUR = 1.25; // ₹/print-hour - belts, lubrication, occasional hotend swaps

  // Actual profit, on top of real cost - everything above this line is cost recovery, not
  // margin. Without this, a perfectly-run order still nets ₹0 for the business.
  var PROFIT_MARGIN_PCT = 0.10;

  // Placeholder only - pincode isn't known yet at this step. The real charge (pickup is
  // free, 24hr/standard delivery are paid) gets confirmed on WhatsApp once we have the
  // address; this just keeps the quote from looking incomplete before that.
  var TRANSPORTATION_ESTIMATE_RS = 75;
  // --------------------------------------------------------------------

  // ---- Modal open/close wired FIRST and independently: the "Get Instant
  // Quote" button must keep working even if the calculator setup below
  // throws (e.g. a missing element), so this can't live after that code. ----
  var overlay = document.getElementById("instant-quote-overlay");
  var modal = document.getElementById("instant-quote-modal");
  var closeBtn = document.getElementById("instant-quote-close");

  function openModal() {
    if (!overlay || !modal) return;
    overlay.classList.add("is-open");
    modal.classList.add("is-open");
    document.body.classList.add("iq-modal-open");
  }

  function closeModal() {
    if (!overlay || !modal) return;
    overlay.classList.remove("is-open");
    modal.classList.remove("is-open");
    document.body.classList.remove("iq-modal-open");
  }

  document.querySelectorAll("[data-open-instant-quote]").forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  });

  if (overlay) overlay.addEventListener("click", closeModal);
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && modal.classList.contains("is-open")) closeModal();
  });

  // ---- Calculator setup below. Wrapped so a failure here can't take out
  // the modal open/close wiring above. ----
  var form = document.getElementById("InstantQuoteForm");
  if (!form) return;

  var fileInput = document.getElementById("IQFile");
  var materialSelect = document.getElementById("IQMaterial");
  var infillSelect = document.getElementById("IQInfill");
  var piecesInput = document.getElementById("IQPieces");
  var colorsInput = document.getElementById("IQColors");
  var submitBtn = document.getElementById("IQSubmit");
  var downloadPdfBtn = document.getElementById("IQDownloadPdf");
  var custNameInput = document.getElementById("IQCustName");
  var custAddressInput = document.getElementById("IQCustAddress");

  var elDropzone = document.getElementById("IQDropzone");
  var elFileRow = document.getElementById("IQFileRow");
  var elFileName = document.getElementById("IQFileName");
  var elFileRemove = document.getElementById("IQFileRemove");
  var elProcessing = document.getElementById("IQProcessing");
  var elResult = document.getElementById("IQResult");
  var elWeight = document.getElementById("IQWeight");
  var elTime = document.getElementById("IQTime");
  var elMaterialCost = document.getElementById("IQMaterialCost");
  var elRunningCost = document.getElementById("IQRunningCost");
  var elProfitMargin = document.getElementById("IQProfitMargin");
  var elTransportation = document.getElementById("IQTransportation");
  var elGrandTotal = document.getElementById("IQGrandTotal");
  var elGst = document.getElementById("IQGst");
  var elTotal = document.getElementById("IQTotal");
  var elWholesaleNote = document.getElementById("IQWholesaleNote");
  var elError = document.getElementById("IQError");
  var infillGroup = document.getElementById("IQInfillGroup");

  // Infill is a free-typed number; the datalist just offers quick presets from config.
  infillSelect.value = DEFAULT_INFILL;
  var infillPresets = document.getElementById("IQInfillPresets");
  if (infillPresets) {
    INFILL_OPTIONS.forEach(function (pct) {
      var opt = document.createElement("option");
      opt.value = pct;
      infillPresets.appendChild(opt);
    });
  }

  function generateQuoteRef() {
    var now = new Date();
    var mm = String(now.getMonth() + 1).padStart(2, "0");
    var yy = String(now.getFullYear() % 100).padStart(2, "0");
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var seq = "";
    for (var i = 0; i < 4; i++) seq += chars.charAt(Math.floor(Math.random() * 26));
    return "BDB/" + mm + "/" + yy + "-" + seq;
  }

  var currentVolumeMm3 = 0; // solid volume parsed from an STL/OBJ/3MF file (estimate path)
  var currentGcodeData = null; // { gramsExact, volumeCm3, lengthMm, hours } from a real slicer's G-code (exact path)
  var currentFileName = "";
  var lastQuote = null; // summary handed to the WhatsApp message on submit, set by recalculate()

  function showError(msg) {
    elError.textContent = msg;
    elError.style.display = msg ? "block" : "none";
  }

  function bytesToText(buffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(buffer, 0, Math.min(buffer.byteLength, 512)));
  }

  // Signed tetrahedron volume sum: closed, consistently-wound mesh -> mm^3
  function signedVolumeOfTriangle(ax, ay, az, bx, by, bz, cx, cy, cz) {
    return (
      (ax * (by * cz - bz * cy) -
        ay * (bx * cz - bz * cx) +
        az * (bx * cy - by * cx)) /
      6.0
    );
  }

  function parseBinarySTL(buffer) {
    var view = new DataView(buffer);
    var triCount = view.getUint32(80, true);
    var expectedSize = 84 + triCount * 50;
    if (Math.abs(expectedSize - buffer.byteLength) > 4) return null; // not really binary

    var volume = 0;
    var offset = 84;
    for (var i = 0; i < triCount; i++) {
      offset += 12; // skip normal
      var ax = view.getFloat32(offset, true), ay = view.getFloat32(offset + 4, true), az = view.getFloat32(offset + 8, true);
      offset += 12;
      var bx = view.getFloat32(offset, true), by = view.getFloat32(offset + 4, true), bz = view.getFloat32(offset + 8, true);
      offset += 12;
      var cx = view.getFloat32(offset, true), cy = view.getFloat32(offset + 4, true), cz = view.getFloat32(offset + 8, true);
      offset += 12;
      offset += 2; // attribute byte count
      volume += signedVolumeOfTriangle(ax, ay, az, bx, by, bz, cx, cy, cz);
    }
    return Math.abs(volume);
  }

  function parseAsciiSTL(text) {
    var vertexRe = /vertex\s+([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)/g;
    var m, coords = [];
    while ((m = vertexRe.exec(text)) !== null) {
      coords.push(parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3]));
    }
    var volume = 0;
    for (var i = 0; i + 8 < coords.length; i += 9) {
      volume += signedVolumeOfTriangle(
        coords[i], coords[i + 1], coords[i + 2],
        coords[i + 3], coords[i + 4], coords[i + 5],
        coords[i + 6], coords[i + 7], coords[i + 8]
      );
    }
    return Math.abs(volume);
  }

  function parseSTL(buffer) {
    var head = bytesToText(buffer).trim();
    if (head.toLowerCase().indexOf("solid") === 0) {
      var asciiVolume = parseAsciiSTL(new TextDecoder("utf-8").decode(new Uint8Array(buffer)));
      if (asciiVolume > 0) return asciiVolume;
    }
    return parseBinarySTL(buffer);
  }

  // OBJ: plain-text vertex/face list. Faces with >3 verts are fan-triangulated;
  // "f 1/2/3" (vertex/uv/normal) and negative (relative) indices are both handled.
  function parseOBJ(text) {
    var vertices = [];
    var volume = 0;
    var lines = text.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (line.charAt(0) === "v" && /\s/.test(line.charAt(1))) {
        var vp = line.split(/\s+/);
        vertices.push([parseFloat(vp[1]), parseFloat(vp[2]), parseFloat(vp[3])]);
      } else if (line.charAt(0) === "f" && /\s/.test(line.charAt(1))) {
        var tokens = line.split(/\s+/).slice(1);
        var idx = tokens.map(function (token) {
          var vi = parseInt(token.split("/")[0], 10);
          if (vi < 0) vi = vertices.length + vi + 1;
          return vi - 1;
        });
        for (var k = 1; k < idx.length - 1; k++) {
          var a = vertices[idx[0]], b = vertices[idx[k]], c = vertices[idx[k + 1]];
          if (!a || !b || !c) continue;
          volume += signedVolumeOfTriangle(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]);
        }
      }
    }
    return Math.abs(volume);
  }

  // 3MF: a zip archive containing XML mesh data at 3D/3dmodel.model.
  var jszipLoadPromise = null;
  function ensureJSZip() {
    if (window.JSZip) return Promise.resolve();
    if (jszipLoadPromise) return jszipLoadPromise;
    jszipLoadPromise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = JSZIP_URL;
      s.onload = function () { resolve(); };
      s.onerror = function () { jszipLoadPromise = null; reject(new Error("Could not load the 3MF parser. Check your connection.")); };
      document.head.appendChild(s);
    });
    return jszipLoadPromise;
  }

  // Scoped to one <mesh> element so multi-object files don't mix vertex lists across objects.
  // transformFn, when given, maps each raw vertex to its final placed position before the
  // volume sum - needed because production-extension 3MFs place components with a transform.
  function meshElementVolume(meshEl, transformFn) {
    var vertexEls = meshEl.getElementsByTagName("vertex");
    var vertices = [];
    for (var i = 0; i < vertexEls.length; i++) {
      var v = vertexEls[i];
      var pt = [parseFloat(v.getAttribute("x")), parseFloat(v.getAttribute("y")), parseFloat(v.getAttribute("z"))];
      if (transformFn) pt = transformFn(pt);
      vertices.push(pt);
    }
    var triangleEls = meshEl.getElementsByTagName("triangle");
    var volume = 0;
    for (var j = 0; j < triangleEls.length; j++) {
      var t = triangleEls[j];
      var a = vertices[parseInt(t.getAttribute("v1"), 10)];
      var b = vertices[parseInt(t.getAttribute("v2"), 10)];
      var c = vertices[parseInt(t.getAttribute("v3"), 10)];
      if (!a || !b || !c) continue;
      volume += signedVolumeOfTriangle(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]);
    }
    return Math.abs(volume);
  }

  // Bambu Studio / OrcaSlicer / PrusaSlicer "project" 3MFs (and anything using the 3MF
  // Production Extension) don't put <mesh> in 3D/3dmodel.model - each object's geometry
  // lives in its own part file inside the zip, referenced from the root file only via
  // <component p:path="..." objectid="..." transform="...">. Summing every <mesh> found
  // in just the root file (the old approach) finds nothing for these, hence "Couldn't
  // find a mesh inside this 3MF file." on files that open fine elsewhere.
  function parseTransform3MF(str) {
    if (!str) return null;
    var n = str.trim().split(/\s+/).map(Number);
    return (n.length === 12 && n.every(function (x) { return !isNaN(x); })) ? n : null;
  }
  function applyTransformToPoint(p, t) {
    return [
      t[0] * p[0] + t[3] * p[1] + t[6] * p[2] + t[9],
      t[1] * p[0] + t[4] * p[1] + t[7] * p[2] + t[10],
      t[2] * p[0] + t[5] * p[1] + t[8] * p[2] + t[11]
    ];
  }
  function toTransformFn(t) { return t ? function (p) { return applyTransformToPoint(p, t); } : null; }
  function chainTransformFns(localFn, outerFn) {
    if (!localFn) return outerFn;
    if (!outerFn) return localFn;
    return function (p) { return outerFn(localFn(p)); };
  }
  function getPathAttr3MF(el) {
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.localName === "path" || /(^|:)path$/.test(a.name)) return a.value;
    }
    return null;
  }
  function findObjectById3MF(doc, id) {
    var objs = doc.getElementsByTagName("object");
    for (var i = 0; i < objs.length; i++) {
      if (objs[i].getAttribute("id") === id) return objs[i];
    }
    return null;
  }
  function getModelDoc3MF(zip, path, cache) {
    var clean = path.replace(/^\//, "");
    if (cache[clean]) return cache[clean];
    var file = zip.file(clean);
    if (!file) {
      var matches = zip.file(new RegExp(clean.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "$", "i"));
      file = matches && matches[0];
    }
    if (!file) return Promise.reject(new Error("A part referenced inside this .3mf file is missing."));
    var p = file.async("string").then(function (xml) {
      var doc = new DOMParser().parseFromString(xml, "application/xml");
      if (doc.getElementsByTagName("parsererror").length) throw new Error("Couldn't parse this .3mf file's mesh data.");
      doc.__path = clean;
      return doc;
    });
    cache[clean] = p;
    return p;
  }
  function resolveObjectVolume3MF(zip, doc, id, transformFn, cache, seen) {
    var key = (doc.__path || "") + "#" + id;
    if (seen[key]) return Promise.resolve(0);
    seen[key] = true;
    var obj = findObjectById3MF(doc, id);
    if (!obj) return Promise.resolve(0);
    var total = 0;
    var meshEl = obj.getElementsByTagName("mesh")[0];
    if (meshEl) total += meshElementVolume(meshEl, transformFn);
    var componentsEl = obj.getElementsByTagName("components")[0];
    if (!componentsEl) return Promise.resolve(total);
    var comps = componentsEl.getElementsByTagName("component");
    var promises = [];
    for (var i = 0; i < comps.length; i++) {
      (function (c) {
        var cid = c.getAttribute("objectid");
        var path = getPathAttr3MF(c);
        var localFn = toTransformFn(parseTransform3MF(c.getAttribute("transform")));
        var childTransformFn = chainTransformFns(localFn, transformFn);
        var docPromise = path ? getModelDoc3MF(zip, path, cache) : Promise.resolve(doc);
        promises.push(docPromise.then(function (childDoc) {
          return resolveObjectVolume3MF(zip, childDoc, cid, childTransformFn, cache, seen);
        }));
      })(comps[i]);
    }
    return Promise.all(promises).then(function (vals) {
      return total + vals.reduce(function (a, b) { return a + b; }, 0);
    });
  }

  function parse3MF(buffer) {
    return ensureJSZip().then(function () {
      return window.JSZip.loadAsync(buffer);
    }).then(function (zip) {
      var modelFile = zip.file("3D/3dmodel.model");
      if (!modelFile) {
        var matches = zip.file(/3dmodel\.model$/i);
        modelFile = matches && matches[0];
      }
      if (!modelFile) throw new Error("No 3D model found inside this .3mf file.");
      return modelFile.async("string").then(function (xmlText) { return { zip: zip, xmlText: xmlText, path: modelFile.name }; });
    }).then(function (ctx) {
      var doc = new DOMParser().parseFromString(ctx.xmlText, "application/xml");
      if (doc.getElementsByTagName("parsererror").length) throw new Error("Couldn't parse this .3mf file's mesh data.");
      doc.__path = ctx.path;
      function fallbackVolume() {
        var meshEls = doc.getElementsByTagName("mesh");
        var totalVolume = 0;
        for (var i = 0; i < meshEls.length; i++) totalVolume += meshElementVolume(meshEls[i]);
        return totalVolume;
      }
      var buildEl = doc.getElementsByTagName("build")[0];
      var items = buildEl ? buildEl.getElementsByTagName("item") : [];
      if (!items.length) return fallbackVolume();
      var cache = {};
      var promises = [];
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        var oid = it.getAttribute("objectid");
        var t = toTransformFn(parseTransform3MF(it.getAttribute("transform")));
        promises.push(resolveObjectVolume3MF(ctx.zip, doc, oid, t, cache, {}));
      }
      return Promise.all(promises).then(function (vals) {
        var total = vals.reduce(function (a, b) { return a + b; }, 0);
        return total > 0 ? total : fallbackVolume();
      });
    });
  }

  function getExtension(filename) {
    var m = /\.([a-z0-9]+)$/i.exec(filename || "");
    var ext = m ? m[1].toLowerCase() : "";
    return (ext === "stl" || ext === "3mf" || ext === "obj" || ext === "gcode" || ext === "gco" || ext === "g") ? ext : null;
  }

  function sumNumbers(str) {
    var matches = (str || "").match(/[\d.]+/g) || [];
    return matches.reduce(function (sum, n) { return sum + parseFloat(n); }, 0);
  }

  // G-code from a real slicer (Bambu Studio, OrcaSlicer, PrusaSlicer, Cura, ...) already has
  // the exact filament weight and print time baked in as header/footer comments - no need to
  // estimate anything. These patterns cover the common slicers; multi-extruder values (comma
  // separated) are summed.
  function parseGcodeWeightGrams(text) {
    var directPatterns = [
      /filament used \[g\]\s*[:=]\s*([\d.,\s]+)/i, // PrusaSlicer / OrcaSlicer / Bambu Studio
      /total filament weight \[g\]\s*:\s*([\d.,\s]+)/i, // Bambu Studio
      /filament weight\d* ?= ?([\d.,\s]+)g/i // Cura (when a material profile with density is set)
    ];
    for (var i = 0; i < directPatterns.length; i++) {
      var m = directPatterns[i].exec(text);
      if (m) {
        var grams = sumNumbers(m[1]);
        if (grams > 0) return grams;
      }
    }
    return 0;
  }

  function parseGcodeVolumeCm3(text) {
    var m = /filament used \[cm3\]\s*[:=]\s*([\d.,\s]+)/i.exec(text);
    return m ? sumNumbers(m[1]) : 0;
  }

  function parseGcodeLengthMm(text) {
    var mmMatch = /filament used \[mm\]\s*[:=]\s*([\d.,\s]+)/i.exec(text);
    if (mmMatch) return sumNumbers(mmMatch[1]);
    var meterMatch = /filament used:\s*([\d.,\s]+)m(?!m)/i.exec(text); // Cura, meters
    if (meterMatch) return sumNumbers(meterMatch[1]) * 1000;
    return 0;
  }

  function parseGcodeTimeHours(text) {
    var secMatch = /;\s*TIME\s*:\s*(\d+)/i.exec(text); // Cura, seconds
    if (secMatch) return parseInt(secMatch[1], 10) / 3600;

    var hmsMatch = /(?:total estimated time|estimated printing time[^=]*=|model printing time)\s*[:=]?\s*(?:(\d+)h\s*)?(?:(\d+)m\s*)?(?:(\d+)s)?/i.exec(text);
    if (hmsMatch && (hmsMatch[1] || hmsMatch[2] || hmsMatch[3])) {
      var h = parseInt(hmsMatch[1] || "0", 10);
      var mins = parseInt(hmsMatch[2] || "0", 10);
      var s = parseInt(hmsMatch[3] || "0", 10);
      return h + mins / 60 + s / 3600;
    }
    return 0;
  }

  // Returns raw numbers rather than a final gram figure, because a direct weight is
  // material-independent (it's whatever the customer's own slicer computed) while a
  // volume/length fallback still needs OUR selected material's density - and that
  // selection can change after the file's already been read.
  function parseGcode(text) {
    var gramsExact = parseGcodeWeightGrams(text);
    var volumeCm3 = gramsExact ? 0 : parseGcodeVolumeCm3(text);
    var lengthMm = (gramsExact || volumeCm3) ? 0 : parseGcodeLengthMm(text);
    var hours = parseGcodeTimeHours(text);

    if (!gramsExact && !volumeCm3 && !lengthMm) {
      throw new Error("Couldn't find filament usage in this G-code. Make sure your slicer includes it in the file (most do by default).");
    }

    return { gramsExact: gramsExact, volumeCm3: volumeCm3, lengthMm: lengthMm, hours: hours };
  }

  function currentMaterial() {
    return MATERIALS[materialSelect.value];
  }

  function formatHours(hours) {
    if (hours < 1) return Math.round(hours * 60) + " min";
    var h = Math.floor(hours);
    var m = Math.round((hours - h) * 60);
    return m > 0 ? h + "h " + m + "m" : h + "h";
  }

  function recalculate() {
    if (!currentVolumeMm3 && !currentGcodeData) return;

    var material = currentMaterial();
    var pieces = Math.max(1, parseInt(piecesInput.value, 10) || 1);
    var isExact = !!currentGcodeData;
    var gramsPerPiece, hoursPerPiece, infillValue;

    if (isExact) {
      var g = currentGcodeData;
      if (g.gramsExact) gramsPerPiece = g.gramsExact;
      else if (g.volumeCm3) gramsPerPiece = g.volumeCm3 * material.density;
      else {
        var radiusCm = (FILAMENT_DIAMETER_MM / 10) / 2;
        var volCm3 = Math.PI * radiusCm * radiusCm * (g.lengthMm / 10);
        gramsPerPiece = volCm3 * material.density;
      }
      hoursPerPiece = g.hours;
      if (infillGroup) infillGroup.style.display = "none";
    } else {
      infillValue = Math.min(100, Math.max(1, parseInt(infillSelect.value, 10) || DEFAULT_INFILL));
      var infillPct = infillValue / 100;

      // Solid-shell + infill-interior approximation: walls/top/bottom always print at
      // ~100%, so infill% is applied only to the fraction of volume beyond the shell.
      var effectiveFraction = infillPct + (1 - infillPct) * SHELL_FACTOR;

      var volumeCm3 = currentVolumeMm3 / 1000;
      gramsPerPiece = volumeCm3 * material.density * effectiveFraction;
      // Estimate only (grams / average print speed) - doesn't affect price, see CONFIG note.
      var speedGPerHour = PRINT_SPEED_G_PER_HOUR[material.base] || 18;
      hoursPerPiece = gramsPerPiece / speedGPerHour;
      if (infillGroup) infillGroup.style.display = "";
    }

    gramsPerPiece = Math.max(1, Math.ceil(gramsPerPiece));
    var totalGrams = gramsPerPiece * pieces;
    var totalHours = hoursPerPiece * pieces;

    var colors = colorsInput ? Math.min(8, Math.max(1, parseInt(colorsInput.value, 10) || 1)) : 1;
    var wasteGrams = SINGLE_COLOR_WASTE_G + Math.max(0, colors - 1) * PURGE_PER_EXTRA_COLOR_G;

    var powerWatts = MATERIAL_POWER_WATTS[material.base] || 100;
    var materialCost = (totalGrams + wasteGrams) * material.rate; // includes purge/skirt waste
    var electricityCost = totalHours * (powerWatts / 1000) * ELECTRICITY_RATE_PER_UNIT;
    var wearCost = totalHours * (PRINTER_PRICE_RS / PRINTER_LIFESPAN_HOURS);
    var maintenanceCost = totalHours * MAINTENANCE_RATE_PER_HOUR;
    var failureBuffer = (materialCost + electricityCost + wearCost) * FAILURE_BUFFER_PCT;
    var runningCost = electricityCost + wearCost + maintenanceCost + CONSUMABLES_COST_RS + failureBuffer;

    var realCost = materialCost + runningCost; // pure cost recovery - no profit yet
    var profitMargin = realCost * PROFIT_MARGIN_PCT;
    var priceBeforeTax = realCost + profitMargin;
    var gst = priceBeforeTax * GST_RATE;
    var total = priceBeforeTax + gst; // this is what actually gets charged (quantity × ₹1)
    if (MIN_CHARGE_RS && total < MIN_CHARGE_RS) total = MIN_CHARGE_RS;
    var grandTotalEstimate = total + TRANSPORTATION_ESTIMATE_RS; // display only, see note below

    var weightSuffix = isExact ? "exact, from G-code" : infillValue + "% infill, estimate";
    elWeight.textContent = totalGrams + " g (" + material.label + ", " + weightSuffix + (pieces > 1 ? ", " + pieces + " pieces" : "") + (colors > 1 ? ", " + colors + " colors" : "") + ")";
    var timeLabel = isExact ? "exact" : "estimate";
    elTime.textContent = pieces > 1
      ? formatHours(totalHours) + " total (" + formatHours(hoursPerPiece) + " each, " + timeLabel + ")"
      : formatHours(totalHours) + " (" + timeLabel + ")";
    elMaterialCost.textContent = "₹" + materialCost.toFixed(2) + (wasteGrams ? " (incl. " + wasteGrams + "g waste)" : "");
    elRunningCost.textContent = "₹" + runningCost.toFixed(2) + " (power, wear, maintenance, buffer)";
    elProfitMargin.textContent = "₹" + profitMargin.toFixed(2) + " (10%)";
    elGst.textContent = "₹" + gst.toFixed(2) + " (18% GST)";
    elTotal.textContent = "₹" + total.toFixed(2);
    elResult.style.display = "block";
    elWholesaleNote.style.display = pieces >= WHOLESALE_MIN_QTY ? "block" : "none";

    var quoteRef = (lastQuote && lastQuote.quoteRef) || generateQuoteRef();
    lastQuote = {
      quoteRef: quoteRef,
      fileName: currentFileName,
      materialLabel: material.label,
      weightLabel: elWeight.textContent,
      timeLabel: elTime.textContent,
      pieces: pieces,
      colors: colors,
      infillLabel: isExact ? "from G-code" : infillValue + "% infill",
      total: total,
      grandTotalEstimate: grandTotalEstimate
    };
    submitBtn.disabled = false;
    if (downloadPdfBtn) downloadPdfBtn.disabled = false;
    showError("");

    saveQuoteToDb({
      quote_ref: quoteRef,
      file_name: currentFileName || null,
      material: material.label,
      infill: isExact ? null : infillValue,
      pieces: pieces,
      colors: colors,
      weight_grams: totalGrams,
      print_hours: totalHours,
      is_exact: isExact,
      material_cost: materialCost,
      running_cost: runningCost,
      profit_margin: profitMargin,
      gst: gst,
      total: total,
      grand_total: grandTotalEstimate,
      sent_whatsapp: false
    });
  }

  var lastSavedQuoteId = null;

  function saveQuoteToDb(quoteData) {
    try {
      fetch(INSTANT_QUOTE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(quoteData)
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.id) lastSavedQuoteId = data.id;
      })
      .catch(function () { /* quote display still works even if save fails */ });
    } catch (e) { /* never block the UI */ }
  }

  function markQuoteWhatsApp() {
    if (!lastSavedQuoteId) return;
    try {
      fetch(INSTANT_QUOTE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ update_id: lastSavedQuoteId, sent_whatsapp: true })
      }).catch(function () {});
    } catch (e) {}
  }

  function setProcessing(isProcessing) {
    elProcessing.style.display = isProcessing ? "block" : "none";
  }

  function resetFile() {
    fileInput.value = "";
    currentVolumeMm3 = 0;
    currentGcodeData = null;
    currentFileName = "";
    lastQuote = null;
    elFileRow.style.display = "none";
    elFileName.textContent = "";
    elResult.style.display = "none";
    setProcessing(false);
    showError("");
    submitBtn.disabled = true;
    if (downloadPdfBtn) downloadPdfBtn.disabled = true;
    if (infillGroup) infillGroup.style.display = "";
  }

  elFileRemove.addEventListener("click", function (e) {
    e.preventDefault();
    resetFile();
  });

  function onVolumeParsed(volume, failureMessage) {
    setProcessing(false);
    if (!volume) {
      showError(failureMessage);
      return;
    }
    showError("");
    currentGcodeData = null;
    currentVolumeMm3 = volume;
    recalculate();
  }

  function onGcodeParsed(data) {
    setProcessing(false);
    showError("");
    currentVolumeMm3 = 0;
    currentGcodeData = data;
    recalculate();
  }

  function handleFile(file) {
    if (!file) return;
    var ext = getExtension(file.name);
    if (!ext) {
      showError("Please upload a .stl, .3mf, .obj, or .gcode file.");
      return;
    }
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      showError("File is larger than " + MAX_FILE_MB + "MB.");
      return;
    }

    elFileName.textContent = file.name;
    elFileRow.style.display = "flex";
    currentFileName = file.name;
    showError("");
    elResult.style.display = "none";
    currentVolumeMm3 = 0;
    currentGcodeData = null;
    setProcessing(true);

    if (ext === "obj") {
      var textReader = new FileReader();
      textReader.onload = function (e) {
        onVolumeParsed(parseOBJ(e.target.result), "Couldn't read this OBJ file. Make sure it's a closed (manifold) mesh.");
      };
      textReader.onerror = function () { setProcessing(false); showError("Couldn't read this file."); };
      textReader.readAsText(file);
      return;
    }

    if (ext === "gcode" || ext === "gco" || ext === "g") {
      var gcodeReader = new FileReader();
      gcodeReader.onload = function (e) {
        try {
          onGcodeParsed(parseGcode(e.target.result));
        } catch (err) {
          setProcessing(false);
          showError(err.message || "Couldn't read this G-code file.");
        }
      };
      gcodeReader.onerror = function () { setProcessing(false); showError("Couldn't read this file."); };
      gcodeReader.readAsText(file);
      return;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      if (ext === "stl") {
        onVolumeParsed(parseSTL(e.target.result), "Couldn't read this STL file. Try re-exporting it from your slicer/CAD tool.");
      } else if (ext === "3mf") {
        parse3MF(e.target.result).then(function (volume) {
          onVolumeParsed(volume, "Couldn't find a mesh inside this 3MF file.");
        }).catch(function (err) {
          setProcessing(false);
          showError(err.message || "Couldn't read this 3MF file.");
        });
      }
    };
    reader.onerror = function () {
      setProcessing(false);
      showError("Couldn't read this file.");
    };
    reader.readAsArrayBuffer(file);
  }

  fileInput.addEventListener("change", function () {
    handleFile(fileInput.files[0]);
  });

  ["dragover", "dragenter"].forEach(function (evt) {
    elDropzone.addEventListener(evt, function (e) {
      e.preventDefault();
      elDropzone.classList.add("is-dragover");
    });
  });
  ["dragleave", "drop"].forEach(function (evt) {
    elDropzone.addEventListener(evt, function (e) {
      e.preventDefault();
      elDropzone.classList.remove("is-dragover");
    });
  });
  elDropzone.addEventListener("drop", function (e) {
    var file = e.dataTransfer.files[0];
    if (!file) return;

    // Rebuild a fresh FileList via DataTransfer and assign it to the real
    // input, so the dropped file actually travels with the form on submit
    // (directly assigning e.dataTransfer.files works in some browsers but
    // not reliably in all of them, which was silently breaking submission
    // while the preview above still looked correct).
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      fileInput.files = dt.files;
    } catch (err) {
      /* unsupported browser: preview still works from `file` directly below */
    }

    handleFile(file);
  });

  materialSelect.addEventListener("change", recalculate);
  infillSelect.addEventListener("input", recalculate);
  piecesInput.addEventListener("input", function () {
    if (piecesInput.value && parseInt(piecesInput.value, 10) < 1) piecesInput.value = 1;
    recalculate();
  });
  if (colorsInput) {
    colorsInput.addEventListener("input", function () {
      if (colorsInput.value && parseInt(colorsInput.value, 10) < 1) colorsInput.value = 1;
      recalculate();
    });
  }

  // A wa.me link can only pre-fill text, never attach a file - the customer's file is
  // already sitting on their device from the picker/drop above, so they just attach the
  // same one once WhatsApp opens.
  function buildWhatsAppMessage(q) {
    var custName = custNameInput ? custNameInput.value.trim() : "";
    var custAddr = custAddressInput ? custAddressInput.value.trim() : "";
    return "Hi Buildabot! I'd like an instant 3D print quote:\n\n" +
      "Quote Ref: " + q.quoteRef + "\n" +
      (custName ? "Name: " + custName + "\n" : "") +
      (custAddr ? "Address: " + custAddr + "\n" : "") +
      (q.fileName ? "File: " + q.fileName + "\n" : "") +
      "Material: " + q.materialLabel + "\n" +
      "Weight: " + q.weightLabel + "\n" +
      "Print time: " + q.timeLabel + "\n" +
      "Pieces: " + q.pieces + "\n" +
      (q.colors > 1 ? "Colors: " + q.colors + "\n" : "") +
      "Infill: " + q.infillLabel + "\n" +
      "Estimated total: ₹" + q.total.toFixed(2) + " + delivery (~₹" + q.grandTotalEstimate.toFixed(2) + " incl. estimate)\n\n" +
      "(Attaching my file now.)";
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (!lastQuote) {
      showError("Upload a file and pick a material first.");
      return;
    }

    markQuoteWhatsApp();
    var url = "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(buildWhatsAppMessage(lastQuote));
    window.open(url, "_blank", "noopener");
  });

  var JSPDF_URL = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
  function loadJsPdf() {
    if (window.jspdf) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = JSPDF_URL;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  if (downloadPdfBtn) {
    downloadPdfBtn.addEventListener("click", function () {
      if (!lastQuote) return;
      var q = lastQuote;
      var custName = custNameInput ? custNameInput.value.trim() : "";
      var custAddr = custAddressInput ? custAddressInput.value.trim() : "";

      loadJsPdf().then(function () {
        var doc = new window.jspdf.jsPDF({ unit: "pt", format: "a4" });
        var pw = doc.internal.pageSize.getWidth();
        var mx = 48, y = 50;

        doc.setFillColor("#EC4123");
        doc.rect(0, 0, pw, 7, "F");

        doc.setFont("helvetica", "bold"); doc.setFontSize(18); doc.setTextColor("#18120D");
        doc.text("Buildabot", mx, y); y += 16;
        doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor("#6F6258");
        doc.text("FDM 3D printing - Chhattisgarh", mx, y); y += 10;

        doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor("#AD301A");
        doc.text("INSTANT QUOTE", pw - mx, 39, { align: "right" });
        doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor("#9B8D81");
        doc.text(q.quoteRef, pw - mx, 53, { align: "right" });
        doc.text(new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }), pw - mx, 65, { align: "right" });

        y += 14;
        doc.setDrawColor("#EC4123"); doc.setLineWidth(1.4); doc.line(mx, y, pw - mx, y);
        y += 28;

        function row(label, val) {
          doc.setFont("helvetica", "normal"); doc.setFontSize(10);
          doc.setTextColor("#6F6258"); doc.text(label, mx, y);
          doc.setTextColor("#18120D"); doc.text(val, pw - mx, y, { align: "right" });
          y += 18;
        }

        if (custName) row("Customer", custName);
        if (custAddr) row("Address", custAddr);
        if (q.fileName) row("File", q.fileName);
        row("Material", q.materialLabel);
        row("Weight", q.weightLabel);
        row("Print time", q.timeLabel);
        row("Pieces", String(q.pieces));
        if (q.colors > 1) row("Colors", String(q.colors));
        row("Infill", q.infillLabel);

        y += 8;
        doc.setDrawColor("#E1D5C7"); doc.setLineWidth(0.5); doc.line(mx, y, pw - mx, y);
        y += 22;

        doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor("#18120D");
        doc.text("Total: Rs. " + q.total.toFixed(2), mx, y);
        doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor("#9B8D81");
        doc.text("+ delivery (confirmed on WhatsApp)", mx, y + 16);

        var pdfName = q.quoteRef.replace(/\//g, "-") + ".pdf";
        doc.save(pdfName);
      }).catch(function () {
        showError("Could not load PDF library. Check your connection.");
      });
    });
  }
})();
